import { Injectable } from "@angular/core";
import { BaseProvider } from "../../../../shared/providers/base-provider";
import { WarningNotifier } from "./warning-notifier";
import { WarningState } from "./warning-state";

@Injectable()
export class WarningProvider extends BaseProvider<
  WarningNotifier,
  WarningState
> {
  constructor() {
    super(WarningNotifier);
  }
}
